import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var borders = {};
export var borderStyles = {};
export var borderWidths = {};
export var letterSpacings = {};
export var opacities = {};
export var radii = {};
export var shadows = {};
export var sizes = {};
export var transitions = {};
export var zIndices = {};
var namedColors = {
  blue: '#262FFF',
  purple: '#5D4FFF',
  'purple-20': '#e8e7ff',
  lightBlue: '#4FD5FF',
  'lightBlue-20': '#e7f7ff',
  deepBlue: '#2A2A3B',
  cyan: '#4FFFF4',
  'cyan-25': '#e0fffc',
  'grey-100': '#000000',
  'grey-90': '#111317',
  'grey-80': '#24262A',
  'grey-70': '#393B3F',
  'grey-60': '#6D6F73',
  'grey-50': '#A0A2A6',
  'grey-40': '#ADAFB3',
  'grey-30': '#C2C4C8',
  'grey-20': '#DFDFE1',
  'grey-10': '#F1F1F3',
  'grey-05': '#F7F7F9',
  'grey-0': '#FFFFFF',
  green: '#38E269',
  orange: '#FFB23F',
  'orange-20': '#fff2e6',
  'orange-25': '#ffeedf',
  lightOrange: '#FFC061',
  'lightOrange-25': '#fff1e2',
  red: '#FF644F',
  'cyan-10': '#EDFFFD',
  'red-20': '#ffe8e7',
  'red-25': '#ffe2e0'
};
export var colors = _objectSpread(_objectSpread({}, namedColors), {}, {
  primary: namedColors.blue,
  secondary: namedColors.cyan,
  success: namedColors.green,
  error: namedColors.red,
  warning: namedColors.orange
});
export var breakpoints = ['768px', '992px'];
export var fonts = {
  base: '"Inter", sans-serif',
  link: '"Inter", sans-serif',
  body: '"Inter", sans-serif',
  heading: '"Inter", sans-serif',
  monospace: 'Menlo, monospace'
};
export var lineHeights = {
  base: '1.5',
  xs: '1.2',
  sm: '1.3',
  md: '1.5',
  lg: '1.5',
  xl: '1.75'
};
export var fontSizes = {
  base: 16,
  xxxxs: 10,
  xxxs: 12,
  xxs: 14,
  xs: 16,
  sm: 18,
  md: 24,
  lg: 28,
  xl: 32,
  xxl: 40,
  xxxl: 48,
  '4xl': 60,
  '5xl': 76,
  '6xl': 92
};
export var fontWeights = {
  thin: 100,
  light: 300,
  base: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  xbold: 800,
  heavy: 900,
  spark: {
    thin: 100,
    light: 300,
    base: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    xbold: 800,
    heavy: 900
  }
};
export var space = {
  base: 16,
  xxxs: 4,
  xxs: 8,
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
  xxl: 64,
  xxxl: 96,
  gutter: 15
};
export var allTokens = {
  breakpoints: breakpoints,
  colors: colors,
  fonts: fonts,
  lineHeights: lineHeights,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  space: space,
  borders: borders,
  borderStyles: borderStyles,
  borderWidths: borderWidths,
  letterSpacings: letterSpacings,
  opacities: opacities,
  radii: radii,
  shadows: shadows,
  sizes: sizes,
  transitions: transitions,
  zIndices: zIndices
};